'use client';

import { useClientTranslation } from '@lib/i18n/client';
import { Trans } from '@tuic/i18n';
import { logger } from '@tuic/logger';
import { TextButton } from '@tuic/web-compositions/core/TextButton';
import { useCallback } from 'react';

import { MXP_DIALOG_NAV_ATTR, MxpModuleId } from './mxp.types';

import type { MxpIframeRef, MxpIframeShareHandler } from './mxp.types';
import type { useToasts } from '@tuic/web-compositions/shared/Toaster';

export function useMxpActionShare() {
  return useCallback<MxpIframeShareHandler>(async args => {
    if (!window.navigator.share) {
      logger.debug('Share API not available');
      return;
    }

    try {
      await window.navigator.share(args);
    } catch (error) {
      logger.debug('Share failed:', error);
    }
  }, []);
}

export function useMxpActionFavoriteAdded(
  push: ReturnType<typeof useToasts>['push'],
  iframeRef: React.RefObject<MxpIframeRef | null>,
) {
  const { t } = useClientTranslation();

  return useCallback(() => {
    let removeSuccessMessage = () => {
      return;
    };

    const handleClick = () => {
      removeSuccessMessage();
      iframeRef.current?.navigateTo(MxpModuleId.Favorites);
    };

    removeSuccessMessage = push({
      title: t('Erfolgreich zur Merkliste hinzugefügt.'),
      text: (
        <Trans>
          Alle gemerkten Inhalte und Aktivitäten finden Sie auf{' '}
          <TextButton
            {...{ [MXP_DIALOG_NAV_ATTR]: true }}
            onClick={handleClick}
          >
            Ihrer Merkliste
          </TextButton>
        </Trans>
      ),
    });
  }, [push, t, iframeRef]);
}
